<template>
  <!-- 去付款弹窗-->
  <van-popup
    v-model="showup"
    position="bottom"
    :overlay="true"
    @click-overlay="showup = false;useBalance=false;"
  >
    <div class="paypopup">
      <div class="paypopup-close">
        <div class="paypopup-closel-x">请选择支付方式</div>
        <div class="paypopup-closel" @click="showup = false;useBalance=false;">
          <img src="../../assets/images/icon_close.svg" alt />
        </div>
      </div>
      <div class="paypopup-amount">支付金额:￥{{paymoney}}</div>
      <div
        :class="parseFloat(user.balance)<=0?'paypopup-useBalance disabled':'paypopup-useBalance'"
      >
        <div class="useBalance-l">余额可抵扣</div>
        <div class="useBalance-r" @click="toUseBalance">
          <div
            class="useBalance-text"
          >￥{{parseFloat(user.balance)>=parseFloat(paymoney)?parseFloat(paymoney):parseFloat(user.balance)}}</div>
          <div class="radius1" v-if="!useBalance"></div>
          <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
        </div>
      </div>
      <div class="paypopup-otherTitle">其他支付方式</div>
      <!--<div-->
      <!--class="paypopup-balance"-->
      <!--@click="xuanz1"-->
      <!--&gt;-->
      <!--<div class="paypopup-balancel">-->
      <!--<img src="../../assets/images/icon_yezf.svg" alt>-->
      <!--<span class="balancePay"><span class="text">余额支付</span><span class="red" v-if="parseFloat(paymoney)-parseFloat(user.balance)>0">当前余额为￥{{parseFloat(user.balance)}}，余额不足</span></span>-->
      <!--</div>-->
      <!--<div class="paypopup-balancer">-->
      <!--<div class="radius" v-if="parseFloat(paymoney)-parseFloat(user.balance)>0"></div>-->
      <!--<img-->
      <!--v-else-if="xuanzhong1"-->
      <!--:src="require('../../assets/images/icon_xuanzhong.png')"-->
      <!--alt-->
      <!--&gt;-->
      <!--<div class="radius1" v-else></div>-->
      <!--</div>-->
      <!--</div>-->
      <div v-if="useNewYouths!='1'" class="paypopup-weixin" @click="xuanz5">
        <div class="paypopup-weixinl">
          <img src="../../assets/images/icon_wxzf.svg" alt />
          <span>微信支付</span>
        </div>
        <div class="paypopup-weixinr">
          <img v-if="payState==4" :src="require('../../assets/images/icon_xuanzhong.png')" alt />
          <div class="radius1" v-else></div>
        </div>
      </div>
      <div class="line" v-if="showAliPay&&useNewYouths!='1'"></div>
      <div v-if="showAliPay&&useNewYouths!='1'" class="paypopup-weixin" @click="xuanz3">
        <div class="paypopup-weixinl">
          <img src="../../assets/images/aliPay.png" alt />
          <span>支付宝支付</span>
        </div>
        <div class="paypopup-weixinr">
          <img v-if="payState==2" :src="require('../../assets/images/icon_xuanzhong.png')" alt />
          <div class="radius1" v-else></div>
        </div>
      </div>
      <div v-if="useNewYouths=='2'" class="line"></div>
      <div v-if="useNewYouths!='0'" class="paypopup-weixin" @click="xuanz2">
        <div class="paypopup-weixinl">
          <img src="../../assets/images/icon_wxzf.svg" alt />
          <span>微信支付{{useNewYouths=='2'?'一':''}}</span>
        </div>
        <div class="paypopup-weixinr">
          <img v-if="payState==1" :src="require('../../assets/images/icon_xuanzhong.png')" alt />
          <div class="radius1" v-else></div>
        </div>
      </div>
      <div  v-if="useNewYouths!='0'" class="linew"></div>
      <div
         v-if="useNewYouths!='0'"
        :class="payState==3?'paypopup-weixin':'paypopup-weixin '"
        @click="xuanz4"
      >
        <div class="paypopup-weixinl">
          <img src="../../assets/images/aliPay.png" alt />
          <span>支付宝支付{{useNewYouths=='2'?'一':''}}</span>
        </div>
        <div class="paypopup-weixinr">
          <div class="radius1" v-if="payState!=3"></div>
          <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
        </div>
      </div>
      <div
        class="paypopup-pay"
        @click="gopay"
      >{{useBalance? parseFloat(user.balance)< parseFloat(paymoney)?'还需支付￥'+Number((parseFloat(paymoney)-parseFloat(user.balance)).toFixed(2)):'立即支付':'立即支付￥'+paymoney}}</div>
    </div>
  </van-popup>
</template>

<script>
import ap from "@/assets/js/ap";
import { mapGetters } from "vuex";
import weChatShareApi from "../../assets/js/weChatShare";

export default {
  components: {},
  props: {
    paymoney: {
      default: "0.00"
    },
    order_number: {
      type: String,
      default: ""
    },
    groupLeaderNbr: {
      type: String,
      default: ""
    },
    state: {
      type: String,
      default: ""
    }
  },
  mixins: [weChatShareApi],
  data() {
    return {
      showup: false, //去付款弹窗
      payState: 4, //
      goPaySwitch: true, // 支付开关
      useNewYouths:'1',
      transSerialNbr: "", //
      weChatProp: {}, // 微信支付属性
      weChatSwitch: true, //支付状态查询持续开关
      payType: "",
      user: {},
      aliUrl: "",
      aliUrl_ys: "",
      useBalance: false,
      testArr: [
        "7193101",
        "18428194",
        "7191977",
        "7433002",
        "7193234",
        "7452877",
        "16295004",
        "18457203",
        "18520355",
        "9326463",
        "18247403",
        "18083662",
        "17608686",
        "18347192",
        "18346055",
        "18402811",
        "18468695",
        "18354296",
        "13656998",
        "18457203",
        "18346286",
        "15494770",
        "18352967",
        "18349301"
      ]
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    showpay() {
      this.showup = true;
    },
    toUseBalance() {
      let balance = parseFloat(this.user.balance);
      if (balance <= 0) {
        return false;
      }
      this.useBalance = !this.useBalance;
    },
    xuanz2() {
      this.payState = 1;
      this.$forceUpdate();
    },
    xuanz3() {
      this.payState = 2;
      this.$forceUpdate();
    },
    xuanz4() {
      this.payState = 3;
      this.$forceUpdate();
    },
    xuanz5() {
      this.payState = 4;
      this.$forceUpdate();
    },
    gopay() {
      if (!this.goPaySwitch) return false;
      this.goPaySwitch = false;
      let that = this;
      let toast = this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      let useBalance = this.useBalance;
      let payAmount = parseFloat(this.paymoney);
      let balance = parseFloat(this.user.balance);
      if (useBalance && balance >= payAmount) {
        that.payType = "BALANCE";
      } else if (this.payState == 1) {
        that.payType = "YOUTHSNEWPUBLICPAY";
      } else if (this.payState == 2) {
        that.payType = "ALIPAYWAP";
      } else if (this.payState == 3) {
        that.payType = "YOUTHSNEWALIPAYWAP";
      } else if (this.payState == 4) {
        that.payType = "YOUTHSPUBLICPAY";
      }
      async function readyPay() {
        return new Promise((resolve, reject) => {
          that.readyPay(resolve, reject);
        });
      }
      async function pay() {
        if (that.payType == "BALANCE") {
          return new Promise((resolve, reject) => {
            that.balancePay(resolve, reject);
          });
        } else if (
          that.payType == "YOUTHSNEWPUBLICPAY" ||
          that.payType == "UNIONPUBLICPAY"
        ) {
          return new Promise((resolve, reject) => {
            that.weChatPay(resolve, reject);
          });
        } else if (that.payType == "ALIPAYWAP") {
          return new Promise((resolve, reject) => {
            that.AliPay(resolve, reject);
          });
        } else if (that.payType == "YOUTHSNEWALIPAYWAP") {
          return new Promise((resolve, reject) => {
            that.AliPay_ys(resolve, reject);
          });
        } else if (that.payType == "YOUTHSPUBLICPAY") {
          return new Promise((resolve, reject) => {
            that.weChatPay(resolve, reject);
          });
        }
      }
      async function goPayMoney() {
        await readyPay();
        await pay();
      }
      goPayMoney();
    },
    readyPay(resolve, reject) {
      let that = this;
      let openid = localStorage.getItem("openid");
      let useBalance = this.useBalance;
       let useNewPayProcess= localStorage.getItem("otherConfig_10025");
      if (
        useBalance &&
        parseFloat(that.paymoney) > parseFloat(that.user.balance)
      ) {
        if(useNewPayProcess=='0'){
          that.$post("/api/pay/readyBalanceUnionPay", {
            userNbr: that.userInfo.nbr,
            orderNbr: that.order_number,
            paymentUnionMethod: "BALANCECASHUNION",
            paymentMethod: that.payType,
            openid: openid,
            balanceAmount: that.user.balance
          }).then(data => {
            if (that.payType == "ALIPAYWAP") {
              that.aliUrl = data;
              resolve();
              return false;
            }
            if (data.code == 200) {
              let resp = data.object.resp;
               if (that.payType == "YOUTHSNEWALIPAYWAP") {
                that.aliUrl_ys = resp.resp.prepayUrl;
                resolve();
                return false;
              }
              if (resp.resp_code == 0 && resp.resp_result == 0) {
                that.weChatProp = resp.resp;
                resolve();
              } else {
                reject();
                that.goPaySwitch = true;
                that.$toast({
                  message: res.resp_msg,
                  duration: 2000
                });
              }
            } else {
              reject();
              that.goPaySwitch = true;
              that.$toast({
                message: data.message,
                duration: 2000
              });
            }
          }).catch(err => {
            reject();
            that.goPaySwitch = true;
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });
        }else if(useNewPayProcess=='1'){
          that.$commonPost({
            jydm: "flow_10000",
            flow_10000: {
              sub_flow: 'flow_30062',
              user_nbr: that.userInfo.nbr,
              order_nbr: that.order_number,
              balance_amount: that.user.balance
            }
          }).then(data => {
            if (data.resp_code == 0 && data.resp_result == 0) {
              that.rechargePay(data.recharge_order_nbr, resolve, reject)
            } else {
              reject();
              that.goPaySwitch = true;
              that.$toast({
                message: data.resp_msg,
                duration: 2000
              });
            }
          })
          .catch(err => {
            reject();
            that.goPaySwitch = true;
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });
        }
      } else {
        that.$post("/api/pay/readyPay", {
            userNbr: that.userInfo.nbr,
            orderNbr: that.order_number,
            paymentMethod: that.payType,
            openid: openid
          })
          .then(data => {
            if (that.payType == "ALIPAYWAP") {
              that.aliUrl = data;
              resolve();
              return false;
            }
            if (data.code == 200) {
              let resp = data.object.resp;
               if (that.payType == "YOUTHSNEWALIPAYWAP") {
                that.aliUrl_ys = resp.resp.prepayUrl;
                resolve();
                return false;
              }
              if (resp.resp_code == 0 && resp.resp_result == 0) {
                if (that.payType == "BALANCE") {
                  that.transSerialNbr = resp.transSerialNbr;
                  resolve();
                }
                if (
                  that.payType == "YOUTHSNEWPUBLICPAY" ||
                  that.payType == "UNIONPUBLICPAY" ||
                  that.payType == "YOUTHSPUBLICPAY"
                ) {
                  that.weChatProp = resp.resp;
                  resolve();
                }
              } else {
                reject();
                that.goPaySwitch = true;
                that.$toast({
                  message: res.resp_msg,
                  duration: 2000
                });
              }
            } else {
              reject();
              that.goPaySwitch = true;
              that.$toast({
                message: data.message,
                duration: 2000
              });
            }
          })
          .catch(err => {
            reject();
            that.goPaySwitch = true;
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });
      }
    },
    rechargePay(orderNbr, resolve, reject){
      let that = this
      let openid = localStorage.getItem("openid");
      that.$post("/api/recharge/readyPay", {
          userNbr: that.userInfo.nbr,
          orderNbr: orderNbr,
          paymentMethod: that.payType,
          openid: openid
        })
        .then(data => {
          if (that.payType == "ALIPAYWAP") {
            that.aliUrl = data;
            resolve();
            return false;
          }
          if (data.code == 200) {
            let resp = data.object.resp;
            if (that.payType == "YOUTHSNEWALIPAYWAP") {
              that.aliUrl_ys = resp.resp.prepayUrl;
              resolve();
              return false;
            }
            if (resp.resp_code == 0 && resp.resp_result == 0) {
              if (that.payType == "BALANCE") {
                that.transSerialNbr = resp.transSerialNbr;
                resolve();
              }
              if (
                that.payType == "YOUTHSNEWPUBLICPAY" ||
                that.payType == "UNIONPUBLICPAY" ||
                that.payType == "YOUTHSPUBLICPAY"
              ) {
                that.weChatProp = resp.resp;
                resolve();
              }
            } else {
              reject();
              that.goPaySwitch = true;
              that.$toast({
                message: res.resp_msg,
                duration: 2000
              });
            }
          } else {
            reject();
            that.goPaySwitch = true;
            that.$toast({
              message: data.message,
              duration: 2000
            });
          }
        })
        .catch(err => {
          reject();
          that.goPaySwitch = true;
          that.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    balancePay(resolve, reject) {
      this.$post("/api/pay/balancePay", {
        transSerialNbr: this.transSerialNbr
      })
        .then(data => {
          if (data.code == 200) {
            let resp = data.object.resp;
            if (resp.resp_code == 0 && resp.resp_result == 0) {
              resolve();
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
              this.showup = false;
              this.getUser();
              this.$emit("paysuccess");
              if (this.state && this.groupLeaderNbr) {
                this.$router.push({
                  path: "/payResultFollow",
                  query: {
                    state: this.state == 1 ? 200 : 201,
                    group_leader_nbr: this.groupLeaderNbr,
                    supNbr: this.userInfo.nbr,
                    orderNbr: this.order_number
                  }
                });
              } else {
                this.$router.push({
                  path: "/payResultFollow",
                  query: {
                    supNbr: this.userInfo.nbr,
                    orderNbr: this.order_number
                  }
                });
              }
            } else {
              reject();
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
            }
          } else {
            reject();
            this.$toast({
              message: data.message,
              duration: 2000
            });
          }
          this.goPaySwitch = true;
        })
        .catch(err => {
          this.goPaySwitch = true;
          reject();
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    weChatPay(resolve, reject) {
      let that = this;
      let weChatPayInfo = that.weChatProp;
      function jsApiCall() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: weChatPayInfo.appId, //公众号名称，由商户传入
            timeStamp: weChatPayInfo.timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: weChatPayInfo.nonceStr, //随机串
            package: "prepay_id=" + weChatPayInfo.prepayid,
            signType: weChatPayInfo.signType, //微信签名方式：
            paySign: weChatPayInfo.sign //微信签名
          },
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.checkWeChatSuccess(resolve, reject);
              let timer = setTimeout(() => {
                that.weChatSwitch = false;
              }, 60000);
            } else if (
              res.err_msg == "get_brand_wcpay_request:cancel" ||
              res.err_msg == "get_brand_wcpay_request:fail"
            ) {
              that.goPaySwitch = true;
              that.showup = false;
              that.$toast({
                message: "支付失败",
                duration: 2000
              });
            }
          }
        );
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", jsApiCall);
          document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
        }
      } else {
        jsApiCall();
      }
    },
    AliPay(resolve, reject) {
      let that = this;
      let aliUrl = "https://openapi.alipay.com/gateway.do?" + that.aliUrl;
      _AP.pay(aliUrl);
    },
    AliPay_ys() {
      let that = this;
      let aliUrl =  that.aliUrl_ys;
      _AP.pay(aliUrl);
    },
    checkWeChatSuccess(resolve, reject) {
      this.$post("/api/pay/order/checkPaySuccess", {
        orderNbr: this.order_number
      })
        .then(data => {
          if (data.code == 200) {
            let resp = data.object.resp;
            if (resp.resp_code == 0) {
              if (resp.resp_result == 0) {
                this.$toast({
                  message: "支付成功",
                  duration: 2000
                });
                resolve();
                this.showup = false;
                this.getUser();
                this.$emit("paysuccess");
                if (this.state && this.groupLeaderNbr) {
                  this.$router.push({
                    path: "/payResultFollow",
                    query: {
                      state: this.state == 1 ? 200 : 201,
                      group_leader_nbr: this.groupLeaderNbr,
                      supNbr: this.userInfo.nbr,
                      orderNbr: this.order_number
                    }
                  });
                } else {
                  this.$router.push({
                    path: "/payResultFollow",
                    query: {
                      supNbr: this.userInfo.nbr,
                      orderNbr: this.order_number
                    }
                  });
                }
              } else if (resp.resp_result == 2 && this.weChatSwitch) {
                setTimeout(() => {
                  this.checkWeChatSuccess(resolve, reject);
                }, 1000);
              } else {
                this.goPaySwitch = true;
                this.showup = false;
                this.$toast({
                  message: "支付失败",
                  duration: 2000
                });
                reject();
              }
            } else {
              this.goPaySwitch = true;
              this.showup = false;
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
              reject();
            }
          } else {
            this.goPaySwitch = true;
            this.showup = false;
            this.$toast({
              message: data.message,
              duration: 2000
            });
            reject();
          }
        })
        .catch(err => {
          this.goPaySwitch = true;
          this.showup = false;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getUser() {
      // 用户的基本信息(身份)
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          this.user = response;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    }
  },
  created() {},
  mounted() {
    if (!(this.userInfo && this.userInfo.nbr)) {
      return;
    }
    this.getUser();
    // this.useNewYouths = localStorage.getItem("otherConfig_10024");
    if(this.useNewYouths!='1'){
        this.payState=4
    }else if(this.useNewYouths=='1'){
      this.payState=1
    }else{
      this.payState=4
    }
  }
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
/*.paypopup-wrap{*/
.line {
  width: calc(100% - 1.04rem);
  height: 1px;
  margin-left: 1.04rem;
  background: #eee;
}
.van-popup {
  border-radius: 0 !important;
  border-top-left-radius: 0.2rem !important;
  border-top-right-radius: 0.2rem !important;
}

.paypopup {
  width: 100%;
  //height: 6.96rem;
}
.paypopup-closel-x {
  font-weight: bold;
  font-size: 0.34rem;
  color: #333333;
  margin: 0 auto;
}
.paypopup-close {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 1.08rem;
  margin-bottom: 0.1rem;
}
.paypopup-close img {
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  top: 0.34rem;
  right: 0.24rem;
}
.paypopup-amount {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 0.65rem;
  font-size: 0.46rem;
  color: #333;
  font-weight: bold;
  margin-bottom: 0.4rem;
}
.paypopup-useBalance {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 0.98rem;
  padding: 0 0.44rem 0 0.36rem;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
}

.useBalance-l {
  font-size: 0.28rem;
  color: #e52b25;
  font-weight: 500;
}
.useBalance-r {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.useBalance-r .useBalance-text {
  font-size: 0.28rem;
  color: #e52b25;
  font-weight: 500;
  margin-right: 0.17rem;
}
.useBalance-r img {
  width: 0.42rem;
  height: 0.42rem;
}
.paypopup-useBalance.disabled .useBalance-l,
.paypopup-useBalance.disabled .useBalance-text {
  color: #ccc;
}
.paypopup-useBalance.disabled .radius1 {
  border: 1px solid #ccc;
}
.paypopup-otherTitle {
  padding-left: 0.34rem;
  height: 0.42rem;
  font-size: 0.3rem;
  color: #333;
  font-weight: bold;
  margin: 0.1rem 0 0.24rem;
}
.paypopup-order {
  width: 100%;
  text-align: center;
  color: #999;
  font-size: 0.32rem;
  margin-top: 0.36rem;
}

.paypopup-money {
  width: 100%;
  font-size: 0.46rem;
  text-align: center;
  font-weight: 500;
  line-height: 0.9rem;
  margin-top: 0.05rem;
}

.paypopup-balance {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 0.98rem;
  margin-top: 1.01rem;
  padding: 0 0.36rem;
  padding-right: 0.44rem;
}

.bg {
  background: #f5f5f5;
}
.paypopup-balancel {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.paypopup-balancel .balancePay {
  margin-left: 0.28rem;
  line-height: 1.08rem;
  display: flex;
  flex-direction: column;
  .text {
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
  .red {
    font-size: 0.2rem;
    color: #e52b25;
    line-height: 0.28rem;
  }
}
.paypopup-balancel img {
  width: 0.4rem;
}
.radius {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.radius1 {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  border: 1px solid #333;
  box-sizing: border-box;
}
.paypopup-balancer img {
  width: 0.42rem !important;
}
.paypopup-weixinr img {
  width: 0.42rem !important;
}
.paypopup-weixinl img {
  width: 0.4rem;
}

.paypopup-weixin {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 0.98rem;
  padding: 0 0.36rem;
  padding-right: 0.44rem;
}

.paypopup-weixinl span {
  margin-left: 0.28rem;
  font-size: 0.28rem;
  line-height: 1.08rem;
}

.paypopup-pay {
  //width: 6.94rem;
  height: 0.98rem;
  background: #e52b25;
  line-height: 0.98rem;
  font-size: 0.3rem;
  text-align: center;
  color: #fff;
  margin-top: 1rem;
  font-weight: bold;
}

/*}*/
</style>



// WEBPACK FOOTER //
// src/components/information/pay.vue